import { SystemError } from "@ascend-ltd/accounts-core";
import { CurrentConfig, EnvironmentTypeLiterals } from "../config";
import { matchType } from "./type-matcher";

export const initializeEnvironmentValue = <R extends string>(
  value: string | undefined
): R => {
  if (value === undefined) {
    throw new SystemError.Unexpected("environment value is undefined");
  }
  return value as R;
};

export const matchEnvironment = <R>(
  matcher: Record<EnvironmentTypeLiterals, R>
) => {
  return matchType(CurrentConfig.env, matcher);
};
